<template>
    <v-app>
        <v-content class="panel-background">
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                        <v-card class="elevation-12">
                            <v-toolbar dark color="primary">
                                <v-toolbar-title>Kinetic Smart Reset Password</v-toolbar-title>
                            </v-toolbar>
                            <v-card-text>
                                <v-card-text>
                                    <v-alert
                                            v-model="alert"
                                            dismissible
                                            v-bind:type="alertType"
                                    >
                                        {{ alertText }}
                                    </v-alert>
                                </v-card-text>
                                <v-form>
                                    <v-text-field prepend-icon="person" name="email" label="Enter email address"
                                                  type="email" v-model="email"></v-text-field>
                                </v-form>
                                <v-card-text>
                                    Return to
                                    <router-link to="/signin">Sign In</router-link>
                                    <br/>
                                    <br/>
                                    <span class="grey--text">&copy; 2019 Kinetic Smart Solutions</span>
                                </v-card-text>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="primary" @click="signIn">Reset</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    const fb = require('../firebase')
    export default {
        name: 'UserReset',
        data() {
            return {
                alert: false,
                alertText: '',
                alertType: 'error',
                email: ''
            }
        },
        mounted() {
            let user = fb.auth.currentUser
            if (user) {
                this.$router.push({path: '/home'})
            }
        },
        methods: {
            signIn: function () {
                if (this.email === '') {
                    this.alertText = 'Please enter an email address for the account you want to reset the password on.'
                    this.alert = true
                } else {
                    fb.auth.sendPasswordResetEmail(this.email)
                        .then(
                            () => {
                                this.alertText = 'A password reset has been send to the email account.'
                                this.alert = true
                                this.alertType = 'success'
                            },
                            (err) => {
                                this.alertText = err.message + ' Please try again.'
                                this.alert = true
                            })
                }
            }
        }
    }
</script>

<style scoped>
    .panel-background {
        background: #395c9c url("../assets/intro.svg") no-repeat fixed top right;
        background-size: 100% 100%;
    }
</style>
